
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { IGameItemForSaleByGala } from '~/store/games/types';

@Component({})
export default class TrailerTakeoverItemContent extends Vue {
  @Prop(String) readonly projectSlug!: string;
  @Prop(Object) readonly item!: IGameItemForSaleByGala;

  formatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: 'USD',
  });

  get itemImage() {
    if (!this.item?.images[0]?.url) {
      return undefined;
    }
    return this.item?.images[0]?.url;
  }

  get itemName() {
    return this.item?.name;
  }

  get itemDescription() {
    return this.item?.description;
  }

  get itemDiscount() {
    if (!this.item?.prices.length) {
      return undefined;
    }

    const usd = this.item?.prices.filter(
      (item) => item.symbol === 'CC-STRIPE',
    )[0];
    const base = parseFloat(usd?.basePrice);
    const sale = parseFloat(usd?.price);

    return sale < base ? this.formatter.format(sale) : undefined;
  }

  get itemPrice() {
    if (!this.item?.prices.length) {
      return undefined;
    }
    const usd = this.item?.prices[0]?.usdBasePriceInCents;
    return this.formatter.format(usd / 100);
  }

  get defaultCurrency() {
    const defaultSelectedCurrency =
      this.item?.prices.filter((item) => item.symbol === 'CC-STRIPE').length > 0
        ? 'CC-STRIPE'
        : this.item?.prices?.[this.item.prices.length - 1]?.symbol;
    return defaultSelectedCurrency;
  }

  get linkToStore() {
    if (!this.item?.baseId) {
      return '';
    }

    const query = this.defaultCurrency
      ? `?currency=${this.defaultCurrency}`
      : ``;
    return `/collections/buy-item/${this.item.baseId}${query}`;
  }
}
